export default __webpack_public_path__ + "static/media/Muskan Bansal.6797ee08.jpg";